// extracted by mini-css-extract-plugin
module.exports = {"instructions":"import-fuel-code_instructions__3kk_r","sampleTemplate":"import-fuel-code_sampleTemplate__3f-tj"};